import React from "react";
import "./Presence.css";

export default function Presence() {
  const countries = [
    { name: "Serbia", code: "rs" },
    { name: "Greece", code: "gr" },
    { name: "Poland", code: "pl" },
    { name: "Norway", code: "no" },
    { name: "Netherlands", code: "nl" },
    { name: "Malta", code: "mt" },
    { name: "Curacao", code: "cw" },
    { name: "Czech Republic", code: "cz" },
    { name: "Denmark", code: "dk" },
    { name: "Estonia", code: "ee" },
    { name: "Georgia", code: "ge" },
    { name: "India", code: "in" },
    { name: "United Kingdom", code: "gb" },
    { name: "Canada", code: "ca" },
    { name: "Brazil", code: "br" },
    { name: "Spain", code: "es" },
    { name: "Italy", code: "it" },
    { name: "Germany", code: "de" },
    { name: "Australia", code: "au" },
    { name: "Japan", code: "jp" },
    { name: "South Korea", code: "kr" },
  ];

  // Duplicate for infinite scroll
  const loopFlags = [...countries, ...countries, ...countries];

  return (
    <section className="presence-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Global Reach</div>
          <h2 className="section-title">
            Our <span className="gradient-text">Presence</span> Worldwide
          </h2>
        </div>
      </div>

      {/* Row 1 - Scroll Left */}
      <div className="scroll-container">
        <div className="scroll-track scroll-left">
          {loopFlags.map((c, i) => (
            <div key={`left-${i}`} className="country-card">
              <div className="flag-wrapper">
                <img
                  src={`https://flagcdn.com/w80/${c.code}.png`}
                  className="flag-image"
                  alt={c.name}
                />
              </div>
              <div className="country-label">{c.name}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Row 2 - Scroll Right */}
      <div className="scroll-container">
        <div className="scroll-track scroll-right">
          {loopFlags.map((c, i) => (
            <div key={`right-${i}`} className="country-card">
              <div className="flag-wrapper">
                <img
                  src={`https://flagcdn.com/w80/${c.code}.png`}
                  className="flag-image"
                  alt={c.name}
                />
              </div>
              <div className="country-label">{c.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
